import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAgencyPortals from '@hooks/useAgencyPortals'

import AgencyPortalListItem from '../AgencyPortalListItem'

interface PortalsProps {
  selectedAgencyId: number,
}

const AgencyPortals = (props: PortalsProps) => {
  const { selectedAgencyId } = props

  const apiKeysPayload = useAgencyPortals({
    filters: {
      agency_id: selectedAgencyId,
    },
    performHttpRequests: !!selectedAgencyId,
    requestOptions: {
      include_agency_portal_auth_token: true,
      include_agency_portal_portal: true,
    },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAgencyPortals,
    filteredAgencyPortalsCount,
    hasFilteredAgencyPortals,
    loading,
  } = apiKeysPayload

  return (
    <DashboardModule
      boxProps={{ borderBottom: `${loading ? 'none' : ''}` }}
      loading={loading}
      title="Portals"
    >
      <Box flexDirection="column">
        {!loading && !hasFilteredAgencyPortals && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Portals Assigned
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              This agency has no portals assigned to it. Portals and CRMs can be used to import campaigns to prevent
              double handling of data.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredAgencyPortals && (
          <DashboardModule.ScrollableSection>
            {filteredAgencyPortals.map(agencyPortal => (
              <AgencyPortalListItem agencyPortal={agencyPortal} key={agencyPortal.id} />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredAgencyPortalsCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}

export default AgencyPortals
